// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error_page[data-v-a6b23398]{background:linear-gradient(rgba(0,0,0,.77),rgba(0,0,0,.77)),url(/images/404_bg.jpeg);background-position:50%;background-repeat:no-repeat;background-size:cover}.error_page .font-oswald[data-v-a6b23398]{-webkit-text-stroke:1px #9ae17b;color:transparent;filter:drop-shadow(0 0 .75rem #ffffff);font-size:200px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
